<div class="section-padding-vertical-md lg:section-padding-vertical-lg w-full flex flex-col gap">
    <div class="split-header-container">
        <h2 class="">Mit diesen Schritten machen wir dich zum Marktführer in deiner Branche.</h2>

        <div class="flex flex-col gap-6">
            <p class="text-xl">
                Es ist leicht, sich in der breiten Masse zu verlieren - es wird Zeit, besser als die
                Konkurrenz zu werden und endlich die Kunden zu bekommen, die du verdienst.
            </p>

            <wci-button routerLink="/kontakt" label="Jetzt Marktführer werden"
                >Jetzt Marktführer werden
            </wci-button>
        </div>
    </div>

    <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8 xl:gap-12">
        <div class="card">
            <div class="flex flex-col gap-4">
                <h3 class="font-normal text-dark">Branding</h3>

                <p>
                    Wir entwickeln ein Branding für dich, das von Anfang an Premium-Qualität
                    vermittelt – ganz gleich, auf welchem Werbemittel es später erscheint.
                </p>
            </div>
        </div>

        <div class="card">
            <div class="flex flex-col gap-4">
                <h3 class="font-normal text-dark">Einzigartiges Design</h3>

                <p>
                    Langweilig? Nein danke! Bei uns entsteht jede Website von Grund auf neu –
                    individuell gestaltet, damit dein Webauftritt potenzielle Kunden überzeugt und
                    nicht aussieht wie tausend andere.
                </p>
            </div>
        </div>

        <div class="card">
            <div class="flex flex-col gap-4">
                <h3 class="font-normal text-dark">Webentwicklung</h3>

                <p>
                    Für uns ist kein Wunsch zu groß, dank unserer Profis unterstützen wir dich bei
                    jeder Custom Lösung für dein Vorhaben.
                </p>
            </div>
        </div>

        <div class="card">
            <div class="flex flex-col gap-4">
                <h3 class="font-normal text-dark">Website Optimierung</h3>

                <p>
                    Mach Schluss mit wirkungslosem Traffic. Mit gezielter Verkaufspsychologie
                    verwandeln wir deine Website in eine echte Verkaufsmaschine!
                </p>
            </div>
        </div>

        <div class="card">
            <div class="flex flex-col gap-4">
                <h3 class="font-normal text-dark">Copy Writing</h3>

                <p>
                    Dank unserer Experten erstellen wir für dich und deine Website optimierte Texte,
                    sodass deinen Besuchern keine andere Wahl bleibt als bei dir zu kaufen!
                </p>
            </div>
        </div>

        <div class="card">
            <div class="flex flex-col gap-4">
                <h3 class="font-normal text-dark">Langfristige Betreuung</h3>

                <p>
                    Wir wissen, dass eine Website kein Einmalprojekt ist. Wir unterstützen dich
                    laufend bei deiner Website, sodass du dich um nichts kümmern musst und dich voll
                    und ganz auf dein Alltagsgeschäft konzentrieren kannst...
                </p>
            </div>
        </div>
    </div>
</div>
